export * as EventTypes from './event-types';

export const INPUT_DEBOUNCE_INTERVAL = 250;
export const ERROR_INVALID_PHONE_NUMBER = 'Invalid phone number!';

export const E164 = 'E.164';
